export default __webpack_public_path__ + "static/7_27-1241fcca9ae39ae2def1c28bb2db74b2.png";